import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { McpTokenSlice } from 'interfaces/initial-states.interface';
import { McpToken, McpTokenIssued } from 'interfaces/mcp-token.interface';
import { McpAgent } from 'interfaces/mcp-agent.interface';
import { initialMcpTokenState } from 'store/initial-states';
import { getMcpAgents, getMcpTokens, createMcpToken } from './extra';

const mcpTokenSlice = createSlice({
  name: 'mcp-token',
  initialState: initialMcpTokenState,
  reducers: {
    updateTokens: (state, { payload }: PayloadAction<McpToken[]>) => {
      state.tokens = payload;
    },
    updateIsFetchingTokens: (state, { payload }: PayloadAction<boolean>) => {
      state.isFetchingTokens = payload;
    },
    updateIsCreatingToken: (state, { payload }: PayloadAction<boolean>) => {
      state.isCreatingToken = payload;
    },
    updateIsRevokingTokenId: (state, { payload }: PayloadAction<string | null>) => {
      state.isRevokingTokenId = payload;
    },
    updateNewlyIssuedToken: (
      state,
      { payload }: PayloadAction<McpTokenIssued | null>
    ) => {
      state.newlyIssuedToken = payload;
    },
    updateShowCreateModal: (state, { payload }: PayloadAction<boolean>) => {
      state.showCreateModal = payload;
    },
    updateShowRevokeConfirmId: (
      state,
      { payload }: PayloadAction<string | null>
    ) => {
      state.showRevokeConfirmId = payload;
    },
    updateMcpAgents: (state, { payload }: PayloadAction<McpAgent[]>) => {
      state.mcpAgents = payload;
    },
    updateIsMcpAgentsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isMcpAgentsLoading = payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getMcpTokens.fulfilled, (state, { payload }) => {
        state.tokens = payload ?? [];
      })
      .addCase(createMcpToken.fulfilled, (state, { payload }) => {
        if (payload) {
          state.newlyIssuedToken = payload as McpTokenSlice['newlyIssuedToken'];
          state.showCreateModal = false;
        }
      })
      .addCase(getMcpAgents.fulfilled, (state, { payload }) => {
        state.mcpAgents = payload ?? [];
      });
  }
});

export const {
  updateTokens,
  updateIsFetchingTokens,
  updateIsCreatingToken,
  updateIsRevokingTokenId,
  updateNewlyIssuedToken,
  updateShowCreateModal,
  updateShowRevokeConfirmId,
  updateMcpAgents,
  updateIsMcpAgentsLoading
} = mcpTokenSlice.actions;

export default mcpTokenSlice.reducer;
